import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaLinkedin, FaTwitter, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: '',
    loading: false
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ ...formStatus, loading: true });
    
    try {
      // Simulating API call for now
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setFormStatus({
        submitted: true,
        success: true,
        message: 'Thank you for reaching out! I will get back to you as soon as possible.',
        loading: false
      });
      
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus({
        submitted: true,
        success: false,
        message: 'There was an error sending your message. Please try again later.',
        loading: false
      });
    }
  };
  
  return (
    <section className="contact-section">
      <Container>
        <motion.div 
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title">Let's Build Something Amazing Together</h1>
          {/* <div className="title-separator"></div> */}
          <p className='section-subtitle'>
            From crafting custom Dynamics 365 solutions to building powerful Power Platform applications, 
            I'm here to help turn your vision into reality.
          </p>
        </motion.div>
        
        <Row className="justify-content-center">
          <Col lg={5} md={12} className="mb-4 mb-lg-0">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="contact-info"
            >
              <h3>Let's Connect</h3>
              <p>
                Feel free to contact me for consulting opportunities, project inquiries, or 
                just to say hello. I'll do my best to respond promptly.
              </p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-text">
                    <h4>Email</h4>
                    <a href="mailto:ajyendrasingh24@gmail.com">ajyendrasingh24@gmail.com</a>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-text">
                    <h4>Phone</h4>
                    <a href="tel:+919718170708">+91 971-817-0708</a>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-text">
                    <h4>Location</h4>
                    <p>Noida, Uttar Pradesh, India</p>
                  </div>
                </div>
              </div>
              
              <div className="social-links">
                <a href="https://www.linkedin.com/in/ajyendra-singh/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://twitter.com/ajyendra_singh" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
              </div>
            </motion.div>
          </Col>
          
          <Col lg={7} md={12}>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="contact-form"
            >
              <h3>Send Me a Message</h3>
              
              {formStatus.submitted && (
                <Alert variant={formStatus.success ? 'success' : 'danger'}>
                  {formStatus.message}
                </Alert>
              )}
              
              <Form onSubmit={handleSubmit}>
                <div className="form-group">
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <Form.Control
                    as="textarea"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your Message"
                    required
                  />
                </div>
                
                <Button 
                  type="submit" 
                  className="submit-btn" 
                  variant="primary" 
                  disabled={formStatus.loading}
                >
                  {formStatus.loading ? 'Sending...' : 'Send Message'}
                </Button>
              </Form>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;